import {AssignAccessAdministrationRolePermissionBody} from "@project/sdk/access-administration/zod";
import type {z} from "zod";
import {requiredStringSchema} from "../../../shared/validation/required-string.schema";
import {accessAdministrationFieldMessages} from "../../messages/access-administration.messages";

export const assignPermissionToRoleFormSchema = AssignAccessAdministrationRolePermissionBody.extend(
  {
    permissionKey: requiredStringSchema(
      AssignAccessAdministrationRolePermissionBody.shape.permissionKey,
      accessAdministrationFieldMessages.permissionKey.id,
    ),
  },
);
export type AssignPermissionToRoleFormPayload = z.output<typeof assignPermissionToRoleFormSchema>;
export const draftAssignPermissionToRoleFormSchema = assignPermissionToRoleFormSchema.partial();
export type DraftAssignPermissionToRoleFormPayload = z.output<
  typeof draftAssignPermissionToRoleFormSchema
>;
